import React from 'react'
import DeleteIcon from 'react-icons/lib/md/delete'

const PotentialItem = (props) => {
  const { potential = {} } = props;
  const structures = {
    0: {},
    1: {}
  };
  potential.structures.forEach((structure, index) => {
    structures[index] = structure;
  })
  return (
    <tr className={`${potential.error ? 'table-danger': potential.status === 'ready' ? '' : 'bg-light'}`}>
      <td>
        {potential.anode}
      </td>
      <td>
        {structures[0].name}
      </td>
      <td>
        {structures[1].name}
      </td>
      <td>
        {potential.error ? potential.error :
          potential.result ? `${Number(potential.result).toFixed(2)} V` : potential.status
        }
      </td>
      <td className="pl-0"><button className="btn btn-transparent p-0" onClick={props.remove} data-id={potential._id}><span className="text-muted"><DeleteIcon/></span></button></td>
    </tr>
  )
}

export default PotentialItem



// WEBPACK FOOTER //
// ./src/containers/project/potential.js